<template>
    <div class="full-chat-w single-page-container">
        <div class="content-box col-sm-8 col-xs-12">
            <div class="element-wrapper">
                <h6 class="element-header">
                    Add Project
                </h6>
                <div class="element-box p-10">
                    <AddSessionForm :session-type="'projectdesk'" :channels="channels" :categories="categories" :selectedUsers="selectedUsers" @stepInterface="onStepChange" @headerInterface="removeUser" />
                </div>
            </div>
        </div>
        <div class="content-panel col-sm-4 col-xs-hidden middle ">
            <div class="content-panel-close">
                <i class="os-icon os-icon-close"></i>
            </div>
            <div class="element-wrapper" v-if="sideBarContent=='users'">
                <h6 class="element-header">Contributors</h6>
                <div class="element-box-tp">
                    <div class="input-search-w row">
                        <div class="col-sm-8">
                            <input class="form-control rounded bright" v-model="userSearch" placeholder="Search users..." type="search">
                        </div>
                        <!-- <div class="col-sm-4">
                            <form class="form-inline justify-content-sm-end">
                                <select class="form-control form-control-sm rounded" style="height: 33px; width: 100%">
                                    <option v-for="role in roles">{{role}}</option>
                                </select>
                            </form>
                        </div> -->
                    </div>
                    <div class="users-list-w">
                        <div class="user-w" v-for="user in filteredUsers">
                            <div class="user-avatar-w header-type">
                                <div class="user-avatar">
                                    <img :src="user.avatar" alt="">
                                </div>
                            </div>
                            <div class="user-name">
                                <h6 class="user-title">{{capitalize(user.name)}}</h6>
                                <div class="user-role">{{user.role_code}}</div>
                            </div>
                            <a class="user-action" @click="addUser(user)">
                                <div class="fal fa-plus"></div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="element-wrapper" v-else>
                <h6 class="element-header">Guide</h6>
                <div class="element-box-tp">
                    <div class="todo-list">
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Channel is required</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Session type is required</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Model is required for Model Shoot</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddSessionForm from '@/components/common/Forms/AddSession'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  components: { AddSessionForm },
  data () {
    return {
      sideBarContent: 'users',
      channels: '',
      categories: '',
      users: '',
      userSearch: '',
      filteredUsers: '',
      selectedUsers: []
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/photodesk/session/add/helper'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.channels = response.data.channels
          self.categories = response.data.categories
          self.users = self.filteredUsers = response.data.users
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
        })
    },
    addUser (header) {
      var session_type = $('select[name="shoot_type"] option:selected').val()
      if (session_type) {
        if (session_type != 'model' && header.role_code == 'model') {
          alert('Models cannot be added to non model sessions')
          return
        }
      } else {
        alert('Select a session type first')
        return
      }
      // check if model is already added
      for (var i = 0; i < this.selectedUsers.length; i++) {
        if (this.selectedUsers[i].role_code === 'model') {
          alert('Only one model is allowed')
          return
        }
      }

      this.selectedUsers.push(header)
      this.$store.dispatch('updateToast', {
        text: 'User added to session',
        show: true
      })
      this.updateUser()
    },
    removeUser (data) {
      console.log('remove')
      for (var i = 0; i < this.selectedUsers.length; i++) {
        if (this.selectedUsers[i].id_user === data.id_user) {
          this.selectedUsers.splice(i, 1)
          break
        }
      }
      this.$store.dispatch('updateToast', {
        text: 'User removed from session',
        show: true
      })
      this.updateUser()
    },
    updateUser () {
      this.filteredUsers = this.users.filter(
        user =>
          !this.selectedUsers.includes(user) &&
          user.name.indexOf(this.userSearch) > -1
      )
    },
    onStepChange (data) {
      this.sideBarContent = data
    }
  },
  computed: {
    roles () {
      var self = this
      const roles = this.users.map(user => {
        return self.capitalize(user.role_code)
      })

      return [...new Set(roles)]
    }
  },
  watch: {
    userSearch () {
      this.updateUser()
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
</style>
